import React, { useEffect, useState } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import { Button } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { endPoints } from "../../../constant/Environment";
import { getAllData, updateUser } from "../../../Utility/API";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
const UserProfile = (props) => {
  const { onClose, open, profileData } = props;
  const [isLoading, setIsLoading] = useState(false);
  // State for form data
  const [formData, setFormData] = useState({
    firstName: profileData?.name || "",
    lastName: profileData?.surname || "",
    address: profileData?.address || "",
    city: profileData?.town || "",
    zipCode: profileData?.zipCode || "",
    state: profileData?.nation || "",
  });

  // State for state dropdown
  const [stateList, setStates] = useState([]);

  useEffect(() => {
    GetStates();
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      firstName: profileData?.name || "",
      lastName: profileData?.surname || "",
      address: profileData?.address || "",
      city: profileData?.town || "",
      zipCode: profileData?.zipCode || "",
      state: profileData?.nation || "",

    });
  }, [profileData]);

  const GetStates = () => {
    let url = `${endPoints.api.STATES}`;
    getAllData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === "success") {
          setStates(data);
        } else {
          console.error("Failed to fetch states");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = async () => {
    let payload = {
      login: profileData?.login,
      idUser: profileData?.idUser,
      country: profileData.country,
      birthDate: profileData?.birthDate,
      sex: "",
      type: "",
      name: formData.firstName,
      surname: formData.lastName,
      town: formData.city,
      address: formData.address,
      zipCode: formData.zipCode,
      nation: formData.state,
    };
    console.log("Updated form data:", payload);
    let url = `${endPoints.api.USER_CASINO_UPDATE}`;

    try {
      setIsLoading(true);
      const response = await updateUser(url, payload);
      setIsLoading(false);
      if (response.status === "success") {
        SuccesToast(response?.message);
        onClose(true);
        // props.GetUserById();
      } else {
        ErrorToast(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <>
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 600 } }}
        maxWidth="sm"
        open={open}
      >
        <DialogTitle>Update Profile</DialogTitle>
        <DialogContent dividers>
          <FormControl fullWidth margin="normal">
            <TextField
              label="First Name"
              name="firstName"
              variant="outlined"
              value={formData.firstName}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth margin="normal">
            <TextField
              label="Last Name"
              name="lastName"
              variant="outlined"
              value={formData.lastName}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth margin="normal">
            <TextField
              label="Address"
              name="address"
              variant="outlined"
              value={formData.address}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth margin="normal">
            <TextField
              label="City"
              name="city"
              variant="outlined"
              value={formData.city}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth margin="normal">
            <TextField
              label="Zip Code"
              name="zipCode"
              variant="outlined"
              value={formData.zipCode}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel id="state-label">State</InputLabel>
            <Select
              labelId="state-label"
              name="state"
              value={formData.state}
              onChange={handleChange}
            >
              {stateList.map((state) => (
                <MenuItem key={state.state_id} value={state.state_id}>
                  {state.state_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel} variant="primary">
            Cancel
          </Button>
          <Button onClick={handleOk} variant="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UserProfile;
